import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { AuthUser, CreateUserRequest, UpdateUserRequest } from '../models/auth.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${API_BASE_URL}/users`;

  getAll(): Observable<AuthUser[]> {
    return this.http.get<AuthUser[]>(this.baseUrl);
  }

  create(request: CreateUserRequest): Observable<AuthUser> {
    return this.http.post<AuthUser>(this.baseUrl, request);
  }

  update(id: string, request: UpdateUserRequest): Observable<AuthUser> {
    return this.http.put<AuthUser>(`${this.baseUrl}/${id}`, request);
  }
}
